import type { SelectProps } from 'antd';

export enum SearchParams {
  divisionSearch = 'divisionSearch',
  search = 'search',
  personnelNumber = 'personnelNumber',
}

export const options: SelectProps['options'] = [
  { value: SearchParams.divisionSearch, label: 'По наименованию подразделения' },
  { value: SearchParams.search, label: 'По ФИО руководителя/замещающего/И.О.' },
  { value: SearchParams.personnelNumber, label: 'По табельному номеру руководителя/замещающего/И.О' },
];
